import Contexts from '../Contexts.js';
import Default from '../contexts/Default.js';
import Gateway from '../Gateway';
import SenderLock from './async/SenderLock';

export default class Event {
  constructor(snowplow) {
    this.event = [];
    this.snowplow = snowplow;
    this.contexts = new Contexts();
    this.type = Default.TYPE_INTERACTION;
  }

  addContext(context) {
     this.contexts.add(context);
  }

  setContexts(contexts) {
    this.contexts = contexts.getContextsCopy();
  }

  send() {
    if (!this._beforeSend()) {
      return;
    }
    this.snowplow.callSnowplow(...this.event);
    this.event = [];
  }

  _beforeSend() {
    if (!this.event.length) {
      throw Error('Event data is empty');
    }
    if (Gateway.isAutoV10 && SenderLock.isLocked()) {
      this.snowplow.pendingEvents.storeEvent(this);
      return false;
    }
    this._pushContextsData();
    return true;
  }

  _pushEventData(name, ...args) {
    this.event.push(this.snowplow.prepareEventName(name), ...args);
  }

  _getDefaultContext() {
    return new Default(this.type);
  }

  _pushContextsData() {
    const allContexts = new Contexts();
    allContexts.add(this._getDefaultContext());
    this.snowplow.globalContexts.getAll().forEach(context => allContexts.add(context));
    this.contexts.getAll().forEach(context => allContexts.add(context));
    this.event.push(allContexts.exportAll());
  }
}
